export const currencyUSFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});
